import { createExtensionService, ExtensionConfig, LoadType } from '@tencent/ark-extensions';
import { showCommonLoader } from './dc-components/common-loader';
import { IDCConfig } from '@src/slide/application/no-edit/common/no-edit-ark-extensions/interface';
import eventBus, { EventKeys } from '@src/slide/infrastructure/module/independent/event-emitter/instance';

const extensionService = createExtensionService({
    metadataLoaderOptions: {
        specifiedVersion: 1,
    },
});

// 暂存 initPromise 的 resolve 函数，用于使 initPromiseResolve 状态转为 fulfilled 状态
let initPromiseResolve: (value?: unknown) => void;
/**
 * 初始化非编辑ark组件
 */
const NoEditArkLoader = {
    // 在 initPromise.then 中 load dc 组件可以保证一定是在 init 之后执行
    initPromise: new Promise(resolve => initPromiseResolve = resolve),
    // ark服务实例（用以注册、获取组件）
    extensionService,
    // 初始化
    init: async (configs: IDCConfig[]): Promise<void> => {
        // 注册dc组件
        await extensionService.scanAndHandleExtensions(configs as ExtensionConfig);
        // 在 init 之后修改 initPromise 的状态
        initPromiseResolve();
        // dc 组件注册结束后加载 common-loader
        eventBus.onIncludingPast(EventKeys.VISIBLE_PAGE_DISPLAY, () => {
            showCommonLoader();
        });
    },
};

export default NoEditArkLoader;
